const URL = import.meta.env.VITE_APPROVAL_URL;

export function getLinkToApprove({ asc_id, wrk_slug }: { asc_id: string; wrk_slug: string }) {
  return `${URL}/${wrk_slug}/${asc_id}`;
}
